import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Recetas from './Recetas';
import './Productos.css';

function Productos() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === '#recetas') {
      const el = document.getElementById('recetas');
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 150);
      }
    }
  }, [location]);

  return (
    <div className="productos-page">
      <Helmet>
        <title>Nuestros Productos y Recetas | Sol de Vainilla</title>
        <meta
          name="description"
          content="Productos 100% artesanales y naturales de vainilla de Costa Rica: vainas gourmet, extracto puro, aceite y plantas, acompañados de exclusivas recetas."
        />
      </Helmet>

      {/* Hero Header matching other pages */}
      <section
        className="productos-hero"
        style={{
          backgroundImage:
            "radial-gradient(circle at center, rgba(14, 25, 12, 0.65) 0%, rgba(10, 18, 9, 0.9) 100%), url('/field2.jpeg')",
        }}
      >
        <div className="container">
          <span className="productos-hero-badge">100% Costarricense</span>
          <h1>Nuestros Productos</h1>
          <p>
            Vainilla 100% pura y artesanal, cultivada y beneficiada con rigurosos estándares botánicos para brindarte el aroma, sabor y calidad más auténticos de Costa Rica.
          </p>
        </div>
      </section>

      {/* Main Products Section */}
      <section className="productos-main-section">
        <div className="container">
          <div className="productos-header-text">
            <span className="section-kicker">CALIDAD GOURMET</span>
            <h2>Catálogo de Productos Exclusivos</h2>
            <div className="recetas-jump-banner">
              <span>¿Buscas inspiración culinaria para tus preparaciones?</span>
              <a href="#recetas" className="recetas-jump-link">
                Ver Recetas Exclusivas ↓
              </a>
            </div>
          </div>

          <div className="product-grid">
            <div className="product-item">
              <div className="product-image-box">
                <img src="/producto5.jpg" alt="Aceite de Coco con Vainilla" />
              </div>
              <h3>Aceite de Coco con Vainilla</h3>
              <p>
                Mezcla artesanal de nuestro aceite de coco puro con extracto botánico de vainilla. Ideal para masajes relajantes, cuidado de la piel y exfoliaciones aromáticas.
              </p>
            </div>

            <div className="product-item">
              <div className="product-image-box">
                <img src="/producto3.jpg" alt="Extracto de Vainilla" />
              </div>
              <h3>Extracto de Vainilla</h3>
              <p>
                Extracto de vainilla artesanal de alta concentración, elaborado con auténticas vainas de vainilla maceradas para obtener un perfil de sabor profundo y natural.
              </p>
            </div>

            <div className="product-item">
              <div className="product-image-box">
                <img src="/producto2.jpg" alt="Vainas Beneficiadas de Vainilla" />
              </div>
              <h3>Vainas Beneficiadas de Vainilla</h3>
              <p>
                Vainas gourmet curadas mediante un proceso tradicional cuidadoso que maximiza su contenido de vainillina, brillo y elasticidad para alta repostería.
              </p>
            </div>

            <div className="product-item">
              <div className="product-image-box">
                <img src="/producto4.jpg" alt="Vainilla en Polvo" />
              </div>
              <h3>Vainilla en Polvo</h3>
              <p>
                Vainilla 100% pura molida a partir de vainas selectas. Sin azúcares ni conservantes añadidos, perfecta para incorporar sabor intenso a mezclas secas y bebidas.
              </p>
            </div>

            <div className="product-item">
              <div className="product-image-box">
                <img src="/producto6.jpg" alt="Planta de Vainilla en Maceta" />
              </div>
              <h3>Planta de Vainilla con Maceta</h3>
              <p>
                Esqueje enraizado de <em>Vanilla planifolia</em> aclimatado y listo para su hogar o jardín, con sustrato nutritivo y guía básica de cuidado doméstico.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Recetas Section integrated under Products */}
      <div id="recetas" className="productos-recetas-section">
        <Recetas />
      </div>
    </div>
  );
}

export default Productos;